export default __webpack_public_path__ + "static/media/home_thumb_tos.fb0c83b2.png";